// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"3e46092e","232":"18f19da0","237":"beba7cab","526":"48bf57b6","872":"4d18df7e"}[chunkId] + ".chunk.js";
};